import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { unsubscribeFromPushManager } from "helpers/notificationHelpers";

/**
 * Resets all user data, used by support team to reset user data in case of issues
 *
 */
function ResetAll() {
  const { logout } = useAuth0();

  // Reset all data
  useEffect(() => {
    // Set tab title
    document.title = `Reset | Cargobase`;

    // clear push subscriptions for notifications
    unsubscribeFromPushManager();

    // Clear Local Storage
    localStorage.clear();

    // Clear Cookies
    clearAllCookies();

    // Logout from Auth0
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  }, [logout]);

  /**
   * Clears all cookies
   */
  function clearAllCookies() {
    document.cookie.split("; ").forEach((cookie) => {
      const [name] = cookie.split("=");
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    });
  }

  return <>All data has been reset.</>;
}

export default ResetAll;
